import React from 'react';
import blogCover from '../images/blog15.png';
import blogCover2 from '../images/blog16.png';
import OurPartner from '../pages/components/OurPartner';
import SuggestedBlogs from './components/SuggestedBlogs';
import { FaUser, FaCalendarAlt, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { features } from "./components/BlogSection";
import { Link } from "react-router-dom";

const currentIndex = features.findIndex(
    (blog) => blog.link === "/web-app-development-at-peregrinee"
);

const prevBlog = features[currentIndex - 1];
const nextBlog = features[currentIndex + 1];

function WebAppDevPeregrinee() {

    const postDate = "March 7, 2026";

    return (
        <>
            {/* BLOG HEADER */}
            <section className="container my-5">

                <div className="text-center mb-4">

                    <h1 className="fw-bold responsive-heading mb-3">
                        <span className="highlight-orange">
                            Web App Development Process at Peregrinee: From Idea to Launch
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        Understanding the modern web app development process at Peregrinee and how we transform ideas into high-performance applications.
                    </p>

                    {/* AUTHOR + DATE */}
                    <div className="d-flex justify-content-center align-items-center gap-4 mt-3 text-muted">

                        <span className="d-flex align-items-center gap-2">
                            <FaUser />
                            Posted by <strong>Peregrinee</strong>
                        </span>

                        <span className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            {postDate}
                        </span>

                    </div>

                </div>

            </section>

            {/* HERO IMAGE */}
            <section className="container mb-5">
                <img
                    src={blogCover}
                    alt="Web App Development Process"
                    className="img-fluid rounded-4 shadow w-100"
                    style={{ maxHeight: "500px", objectFit: "cover" }}
                />
            </section>


            {/* SECTION 1 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6">
                        <img
                            src={blogCover}
                            alt="Web App Idea & Planning"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />
                    </div>

                    <div className="col-lg-6">

                        <h3 className="fw-bold highlight-orange">Idea & Discovery</h3>

                        <p>
                            Every successful web application starts with a clear idea. At Peregrinee,
                            we work closely with clients to understand their vision, business goals,
                            and user needs. This discovery phase includes requirement gathering,
                            competitor analysis, and feasibility study to ensure the project has
                            a strong foundation.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Planning & Strategy
                        </h3>

                        <p>
                            Once the idea is validated, our team creates a detailed roadmap,
                            including project milestones, technology stack selection, and
                            resource allocation. Clear planning ensures smooth execution
                            and timely delivery while aligning with business objectives.
                        </p>

                    </div>

                </div>

            </section>


            {/* SECTION 2 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6 order-lg-1 order-2">

                        <h3 className="fw-bold highlight-orange">
                            Design, Development & Launch
                        </h3>

                        <p>
                            Our UI/UX designers craft intuitive interfaces, ensuring a seamless
                            user experience. The development team then builds the application
                            using scalable and secure architectures. Rigorous testing guarantees
                            performance and reliability.
                        </p>

                        <p>
                            Finally, we deploy the web app, monitor initial usage, and provide
                            support for smooth operation.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Continuous Improvement
                        </h3>

                        <p>
                            Web applications are never static. We offer ongoing maintenance,
                            updates, and feature enhancements to keep your application
                            competitive, secure, and aligned with evolving user needs.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold mt-3"
                            style={{ width: "fit-content" }}
                        >
                            Start Your Web App Journey with Peregrinee
                        </a>

                    </div>

                    <div className="col-lg-6 order-lg-2 order-1">

                        <img
                            src={blogCover2}
                            alt="Web App Design & Launch"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                </div>

            </section>


            {/* BLOG NAVIGATION */}
            <section className="container my-5">

                <div className="row">

                    {/* PREVIOUS BLOG */}
                    {prevBlog && (
                        <div className="col-md-6 mb-3">

                            <Link
                                to={prevBlog.link}
                                className="d-flex align-items-center gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <FaArrowLeft />

                                <div>
                                    <small className="text-muted">Previous Blog</small>
                                    <h6 className="mb-0 fw-bold">{prevBlog.title}</h6>
                                </div>

                            </Link>

                        </div>
                    )}

                    {/* NEXT BLOG */}
                    {nextBlog && (
                        <div className="col-md-6 mb-3 text-md-end">

                            <Link
                                to={nextBlog.link}
                                className="d-flex align-items-center justify-content-md-end gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <div>
                                    <small className="text-muted">Next Blog</small>
                                    <h6 className="mb-0 fw-bold">{nextBlog.title}</h6>
                                </div>

                                <FaArrowRight />

                            </Link>

                        </div>
                    )}

                </div>

            </section>


            {/* SUGGESTED BLOGS */}
            <SuggestedBlogs />

            <OurPartner />

        </>
    );
}

export default WebAppDevPeregrinee;